import Vue from 'vue';
import wysiwyg from "vue-wysiwyg";

import router from '@/plugins/router';
import '@/plugins/bootstrapVue';
import '@/plugins/axios';
import '@/plugins/auth';
import '@/plugins/icons';
import '@/plugins/sentry';
import '@/plugins/moment';
import '@/mixins/global_mixin';
import '@/plugins/websocket';
import i18n from '@/i18n';

import Gate from "@/policies/Gate";
import App from "@/App";
import '@/components'

import * as Sentry from '@sentry/vue';


Vue.use(wysiwyg, {});
Vue.config.devtools = true

Vue.prototype.$gate = new Gate({});

export default new Vue({
    router,
    i18n,
    watch: {
        isAuthenticated(isAuthenticated) {
            if (isAuthenticated) {
                Vue.prototype.$gate = new Gate(this.$auth.user());

                Sentry.setUser(this.$auth.user());

                this.$echo.connector.options.auth.headers['Authorization'] = 'Bearer ' + this.$auth.token();
                this.$echo.connect();
                this.listenForNotifications();
            } else {
                Vue.prototype.$gate = new Gate({});
            }
        }
    },
    mounted() {
        if (this.isAuthenticated) {
            this.listenForNotifications();
        }
    },

    methods: {
        listenForNotifications() {
            this.$echo.private('App.User.' + this.$auth.user().id).notification((notification) => {
                console.log(notification)
                if (notification.downloadUrl){

                    let vNodesMsg = this.$createElement(
                        'a',
                        {
                            attrs:{
                                href: notification.downloadUrl,
                                target: '_blank'
                            }
                        },
                        [
                            notification.message
                        ]
                    )
                    console.log(vNodesMsg)

                    this.$root.$bvToast.toast([vNodesMsg], {
                        title: notification.title,
                        solid: true,
                        variant: 'info',
                        noAutoHide: true
                    });

                }else{
                    this.$root.$bvToast.toast(notification.message, {
                        title: notification.title,
                        solid: true,
                        variant: 'info',
                    });
                }


            });
        }
    },
    render: h => h(App)
}).$mount('#app');
